import type { SettingChange } from "./settings-draft.context"; 
import type { MediaUpdateBody } from "../../../../page-controller-mod/page-serv/settings/media-management-set/ts/setting-digital.type";

export const buildMediaPayload = (changes: SettingChange[]): MediaUpdateBody => {  //NOSONAR
  const body: MediaUpdateBody = {};
  
  const ensure = { 
    del: () => (body.delete ??= {}),  //NOSONAR
    delConfirm: () => ((body.delete ??= {}).confirm ??= {}), //NOSONAR
    delUsed: () => ((body.delete ??= {}).used ??= {}),   //NOSONAR
    name: () => (body.name ??= {}),  //NOSONAR
    alt: () => (body.alt ??= {}),  //NOSONAR
    upload: () => (body.upload ??= {}),  //NOSONAR
    uploadPersonal: () => ((body.upload ??= {}).personal ??= {}),  //NOSONAR
    asset: /* istanbul ignore next */ () => (body.asset ??= {}),
    assetUse: () => ((body.asset ??= {}).use ??= {}),  //NOSONAR
  };

  for (const c of changes) {
    if (c.pageKey !== "digital-asset") continue;

    // toggles
    if (c.type === "toggle") {
      const v = Boolean(c.value);

      // Group 1 — Asset Information
      if (c.groupId === 1 && c.itemId === 1) ensure.name().required = v;            
      if (c.groupId === 1 && c.itemId === 2) ensure.alt().required = v;            

      // Group 2 — Asset Policy
      if (c.groupId === 2 && c.itemId === 1) ensure.delConfirm().enabled = v;     
      if (c.groupId === 2 && c.itemId === 2) ensure.del().enabled = v;            
      if (c.groupId === 2 && c.itemId === 3) ensure.delUsed().enabled = v;        
      if (c.groupId === 2 && c.itemId === 4) ensure.assetUse().enabled = v;       

      // Group 3 — Asset Caching
      if (c.groupId === 3 && c.itemId === 1) ensure.uploadPersonal().enabled = v;   

      // Group 4 Media selection
      // if (c.groupId === 3 && c.itemId === 3) ensure.assetUse().enabled = v; 

      continue;
    }

    // inputs
    /* istanbul ignore next */
    if (c.type === "input") {
      // Group 3 Item 2 => upload.maxFileSizeMb
      if (c.groupId === 3 && c.itemId === 2) {
        const raw = String(c.value).trim().toLowerCase().replace("mb", "").trim();
        const num = Number(raw);
        if (!Number.isFinite(num)) continue;
        ensure.upload().maxFileSizeMb = num;
      }
    }
  }

  return body;
};